import { useQuery } from '@tanstack/react-query';
import { fetchBundles } from './fetchBundles';
import { GlobalReactQueryOptions } from '../../config';

type Params = {
    page?: number;
    pageSize?: number;
    sortBy?: string;
    category?: string;
    ageCategory?: string;
    includeProducts?: boolean;
    loanFormat?: string;
};

const BUNDLES_KEY = `bundles`;

export const useBundles = (params: Params) => {
    return useQuery([BUNDLES_KEY, params], () => fetchBundles(params), {
        ...GlobalReactQueryOptions
    });
};
